// @flow

import * as React from 'react';
import {
    Box, Button, Collapsible,
} from 'grommet';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';


type Props = {
    value: boolean,
    intl: IntlShape,
}

type State = {
    showContent: boolean,
}

const messages = defineMessages({
    'jsoncolumnn-button-label': {
        id: 'jsoncolumnn-button-label',
        defaultMessage: 'View JSON',
    },
});

const StyledButton = styled(Button)`
    font-family: "Open Sans", sans-serif;
    font-size: 0.8rem;
    font-weight: 400;
    border-width: 1px;
    border-radius: 7px;
    line-height: 18px;
`;

class JSONCell extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { showContent: false };
    }

    setShowModal = () => this.setState((prevState) => ({ showContent: !prevState.showContent }));

    render() {
        const { value, intl: { formatMessage } } = this.props;
        const { showContent } = this.state;

        return (
            <>
                <StyledButton
                    size="small"
                    onClick={this.setShowModal}
                    label={formatMessage(messages['jsoncolumnn-button-label'])}
                />
                <Collapsible direction="vertical" open={showContent}>
                    <Box overflow={{ horizontal: 'auto' }}>
                        <pre>
                            {JSON.stringify(value, null, 2)}
                        </pre>
                    </Box>
                </Collapsible>
            </>
        );
    }
}

const Cell = (props: Props) => (
    <JSONCell {...props} />
);

export default injectIntl(Cell);
